import angular from 'angular';

import ForgotPasswordTokenExpiredComponent from './forgot-password-token-expired.cmpt';

export default angular
    .module('application.scene.identity.scene.forgot-password-token-expired', [])
    .component(ForgotPasswordTokenExpiredComponent.selector, ForgotPasswordTokenExpiredComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.forgot-password.token-expired', {
        url: '/reset',
        template: '<db-a-forgot-password-token-expired class="block-component"></db-a-forgot-password-token-expired>'
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-token-expired/index.js